import Image from "next/image";
import { Link } from "next-view-transitions";
import type React from "react";
import { cn } from "~/lib/utils";

interface LogoProps extends React.HTMLAttributes<HTMLDivElement> {
  disabledLink?: boolean;
  innerRef?: React.Ref<HTMLImageElement>;
}

const Logo: React.FC<LogoProps> = ({
  disabledLink = false,
  className,
  innerRef,
  ...other
}) => {
  const logo = (
    <Image
      ref={innerRef}
      src="/assets/logo.svg"
      alt="Simone Trollmo logo"
      width={30}
      height={30}
      className={cn(
        "min-h-7.5 min-w-7.5 cursor-pointer hover:opacity-80",
        className,
      )}
      {...other}
    />
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link prefetch href="/">
      {logo}
    </Link>
  );
};

export default Logo;
